import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section id="guide" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          <div className="flex-1 w-full">
            <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20fashion%20items%20including%20sneakers%20watch%20sunglasses%20and%20magazine%20scattered%20on%20white%20desk%2C%20overhead%20shot%20with%20soft%20natural%20light%2C%20editorial%20lifestyle%20photography%2C%20minimalist%20scandinavian%20aesthetic%2C%20clean%20organized%20composition%20with%20laptop%20and%20coffee%20cup&width=800&height=600&seq=seo-collage-v2&orientation=landscape"
                alt="Curated PandabuySpreadsheet product collection guide"
                className="w-full h-full object-cover object-top"
                title="PandabuySpreadsheet Curated Guide"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-semibold text-accent-700 uppercase tracking-wider mb-4 bg-accent-50">
              Pandabuy Guide
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              What Is a<br />
              Pandabuy Sheet?
            </h2>
            <p className="mt-5 text-base text-foreground-600 leading-relaxed">
              A <strong>PandabuySpreadsheet</strong> is a curated system of organized product lists that helps shoppers quickly discover trending fashion, sneakers, and accessories without searching manually. Instead of endless scrolling, users browse structured spreadsheets packed with price comparisons, quality ratings, category filtering, and direct item links — making the entire shopping experience faster and smarter.
            </p>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              Whether you are hunting for budget-friendly streetwear, luxury-style dupes, or viral TikTok finds, a well-organized PandabuySpreadsheet puts everything at your fingertips. Updated weekly with fresh discoveries, these spreadsheets have become the go-to resource for savvy shoppers worldwide.
            </p>
            <Link
              to="/pandabuy-sheet-ultimate-guide"
              className="inline-flex items-center gap-2 mt-6 bg-foreground-950 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Read Full Guide
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}